import fscreen from 'fscreen';
import { useState, useEffect, RefObject } from 'react';

export type Fullscreen = {
  enabled: boolean;
  enable: () => void;
  disable: () => void;
  available: boolean;
};

const useFullscreen = (targetRef?: RefObject<HTMLElement | null>): Fullscreen => {
  const [enabled, setEnabled] = useState(false);
  // Read after mount: fscreen reports false without a document (server rendering), so the
  // first client render must too, or hydration would mismatch on the fullscreen button.
  const [available, setAvailable] = useState(false);

  const enable = () => {
    const element = targetRef?.current || document.documentElement;
    fscreen.requestFullscreen(element);
  };

  const disable = () => {
    fscreen.exitFullscreen();
  };

  useEffect(() => {
    setAvailable(fscreen.fullscreenEnabled);

    const changed = () => {
      setEnabled(fscreen.fullscreenElement !== null);
    };

    fscreen.addEventListener('fullscreenchange', changed);

    return () => {
      if (fscreen.fullscreenElement) disable();
      fscreen.removeEventListener('fullscreenchange', changed);
    };
  }, []);

  return {
    enabled,
    enable,
    disable,
    available,
  };
};

export default useFullscreen;
